import { action } from "@ember/object"
import { later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Group, GroupMembership } from "@shared/models/group"
import { handleError } from "cc-frontend/error-handling"
import type Dialog from "cc-frontend/services/dialog"
import type EmberStore from "cc-frontend/services/ember-store"
import type Rpc from "cc-frontend/services/rpc"
import { isGroupMembershipAccepted, isGroupMembershipInvited } from "cc-frontend/utils/group"
import { tracked } from "tracked-built-ins"

interface Signature {
  Args: {
    row: GroupMembership
    group: Group
  }
}

export default class GroupMembersTableActionsCell extends Component<Signature> {
  @service("ember-store") declare store: EmberStore
  @service declare rpc: Rpc
  @service declare dialog: Dialog
  @tracked removingUser = false

  rpcToRemoveUser(groupId: string, email: string) {
    this.rpc
      .group_remove_individual({
        email: email,
        groupId: groupId,
      })
      .then(() => {
        if (this.isDestroyed || this.isDestroying) return
        later(() => (this.removingUser = false), 250)
      })
  }

  @action
  removeMember() {
    this.dialog
      .blank("dialogs/confirm-delete-membership", {
        className: "dialog--create-annotation",
      })
      .then(() => {
        this.removingUser = true
        if (isGroupMembershipAccepted(this.args.row)) {
          this.store.find("user-summary", this.args.row.attributes.userId).then((model) => {
            this.rpcToRemoveUser(this.args.group.id, model.attributes.email)
          })
        }
        if (isGroupMembershipInvited(this.args.row)) {
          this.rpcToRemoveUser(this.args.group.id, this.args.row.attributes.email)
        }
      })
      .catch((error) => {
        if (error instanceof Error) handleError(error)
      })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Group::MembersTable::Cells::ActionsRemove": typeof GroupMembersTableActionsCell
  }
}
